<section class="page">
  <div class="page__header">
    <h1>Plateaux</h1>
    <div class="actions">
      <spw-text-field
        label="Nom du plateau"
        name="plateauName"
        [value]="newPlateauName"
        placeholder="Nom du plateau"
        (valueChanged)="updatePlateauName($event.detail)"
      ></spw-text-field>
      <spw-button variant="primary" [disabled]="isSubmitting" (click)="createPlateau()">
        {{ isSubmitting ? 'Création...' : 'Créer' }}
      </spw-button>
    </div>
  </div>
  <spw-message
    *ngIf="successMessage"
    [messageTitle]="'Succès'"
    variant="success"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ successMessage }}
  </spw-message>
  <spw-message
    *ngIf="errorMessage"
    [messageTitle]="'Erreur'"
    variant="alert"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ errorMessage }}
  </spw-message>
  <spw-table>
    <spw-table-head>
      <spw-table-row>
        <spw-table-header>Nom</spw-table-header>
        <spw-table-header>Actions</spw-table-header>
      </spw-table-row>
    </spw-table-head>
    <spw-table-body>
      <spw-table-row *ngFor="let plateau of plateaux">
        <spw-table-cell>
          <div *ngIf="editingPlateauId === plateau.id; else plateauName">
            <input [(ngModel)]="editPlateauName" class="inline-input" />
          </div>
          <ng-template #plateauName>{{ plateau.name }}</ng-template>
        </spw-table-cell>
        <spw-table-cell>
          <div class="row-actions">
            <spw-button variant="secondary" (click)="openSettings(plateau)">Paramètres</spw-button>
            <spw-button
              *ngIf="editingPlateauId !== plateau.id"
              variant="secondary"
              (click)="startEdit(plateau)"
            >
              Modifier
            </spw-button>
            <spw-button
              *ngIf="editingPlateauId === plateau.id"
              variant="primary"
              [disabled]="isUpdating"
              (click)="updatePlateau()"
            >
              {{ isUpdating ? 'Mise à jour...' : 'Enregistrer' }}
            </spw-button>
            <spw-button
              *ngIf="editingPlateauId === plateau.id"
              variant="secondary"
              (click)="cancelEdit()"
            >
              Annuler
            </spw-button>
            <spw-button
              variant="danger"
              [disabled]="deletingPlateauId === plateau.id"
              (click)="deletePlateau(plateau)"
            >
              {{ deletingPlateauId === plateau.id ? 'Suppression...' : 'Supprimer' }}
            </spw-button>
          </div>
        </spw-table-cell>
      </spw-table-row>
    </spw-table-body>
  </spw-table>
  <div class="empty" *ngIf="plateaux.length === 0">Aucun plateau pour le moment.</div>

  <div class="settings" *ngIf="selectedPlateau">
    <h2>Paramètres — {{ selectedPlateau.name }}</h2>
    <div class="loading" *ngIf="isSettingsLoading">
      <spw-loading></spw-loading>
    </div>
    <div class="settings__form" *ngIf="!isSettingsLoading && settingsForm">
      <spw-text-field
        label="Litres par paquet"
        type="number"
        [value]="settingsForm.litresParPaquet"
        (valueChanged)="updateSetting('litresParPaquet', $event.detail)"
      ></spw-text-field>
      <spw-text-field
        label="Litres par mug"
        type="number"
        [value]="settingsForm.litresParMug"
        (valueChanged)="updateSetting('litresParMug', $event.detail)"
      ></spw-text-field>
      <spw-text-field
        label="Horizon de planning"
        type="number"
        [value]="settingsForm.planningHorizon"
        (valueChanged)="updateSetting('planningHorizon', $event.detail)"
      ></spw-text-field>
      <spw-text-field
        label="Cooldown warning (minutes)"
        type="number"
        [value]="settingsForm.warningCooldownMinutes"
        (valueChanged)="updateSetting('warningCooldownMinutes', $event.detail)"
      ></spw-text-field>
      <div class="settings__actions">
        <spw-button variant="primary" [disabled]="isSettingsSaving" (click)="saveSettings()">
          {{ isSettingsSaving ? 'Enregistrement...' : 'Enregistrer' }}
        </spw-button>
      </div>
    </div>
  </div>
</section>
